import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { FileGridComponent } from './Modules/file-grid/file-grid.component';
import { HomeComponent } from './Modules/home/home.component';
import { CBEMComponent } from './Modules/CBEM/cbem.component';
import { ClientTrackerComponent } from './Modules/client-navigator/client-navigator.component';
import { ClientDashboardComponent } from './Modules/client-dashboard/client-dashboard.component';
import { ReferralComponent } from './Modules/referral/referral.component';
import { ReferralDetailComponent } from './Modules/referral-detail/referral-detail.component';
import { DynamoUtilityComponent } from './Modules/dynamo-utility/dynamo-utility.component';
import { featureFlagCanMatch } from './core/guards/FeatureFlagGuard';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full'  },
  { path: 'login/callback', component: OktaCallbackComponent },
  { path: 'home', component: HomeComponent,
    canActivate: [OktaAuthGuard],
   },
  { path: 'fileGrid', component: FileGridComponent,
    canActivate: [OktaAuthGuard, featureFlagCanMatch],
    data: {flag: 'invoice-extract-visible'}
    },
  { path: 'CBEM', component: CBEMComponent,
    canActivate: [OktaAuthGuard, featureFlagCanMatch],
    data: {flag: 'CBEM-visible'}
    },
  { path: 'ClientNav', component: ClientTrackerComponent,
    canActivate: [OktaAuthGuard, featureFlagCanMatch],
    data: {flag: 'master-client-visible'}
    },
  { path: 'ClientNavigator/:name', component: ClientDashboardComponent,
    canActivate: [OktaAuthGuard, featureFlagCanMatch],
    data: {flag: 'master-client-visible'}
    },
  { path: 'Referrals', component: ReferralComponent,
    canActivate: [OktaAuthGuard, featureFlagCanMatch],
    data: {flag: 'gb-referrals-visible'}
    },
  { path: 'ReferralDetail/:refNumber', component: ReferralDetailComponent,
    canActivate: [OktaAuthGuard, featureFlagCanMatch],
    data: {flag: 'gb-referrals-visible'}
    },
  { path: 'DynamoUtility', component: DynamoUtilityComponent,
    canActivate: [OktaAuthGuard, featureFlagCanMatch],
    data: {flag: 'utility-visible'}
    },

 // { path: 'entries', component: LettersTableComponent, canActivate: [OktaAuthGuard,HomeAccessGuard]},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
